export const COMMENT_LABEL_CALL: string = 'call';
export const COMMENT_LABEL_EMAIL: string = 'email';
export const COMMENT_LABEL_MEETING: string = 'meeting';
export const COMMENT_LABEL_FOLLOW_UP: string = 'follow-up';
